import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { addArea, updateArea } from '../../../../api/firebase';
import PlantForm from '../forms/PlantForm';
import PlantAreaList from './PlantAreaList';

const PlantAreas = (props) => {
  const [editArea, setEditArea] = useState(null);

  const showPlants = (area) => {
    props.showPlants(area);
  };

  const resetEdit = () => {
    setEditArea(null);
  };

  const updateAreaInFb = async (area) => {
    if (
      area.name !== editArea.name ||
      area.description !== editArea.description
    ) {
      props.setLoading(true);
      try {
        await updateArea(
          { name: area.name, description: area.description },
          area.id
        );
        props.setLoading(false);
        props.fetchAreas();
        setEditArea(null);
        return;
      } catch (err) {
        toast.error(err.message, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
        props.setLoading(false);
        return;
      }
    }
    setEditArea(null);
    toast.error('No change in form!', {
      position: toast.POSITION.BOTTOM_LEFT,
    });
  };

  const addAreaInFb = async (area) => {
    if (!area.name || !area.description) return;

    props.setLoading(true);
    try {
      await addArea({
        name: area.name,
        description: area.description,
        isDeleted: false,
      });
      props.fetchAreas();
    } catch (err) {
      toast.error(err.message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    props.setLoading(false);
  };

  const addUpdateArea = async (area) => {
    if (area.id) {
      await updateAreaInFb(area);
      return;
    }
    await addAreaInFb(area);
  };

  const deleteAreaAndPlants = async (areaId) => {
    props.setLoading(true);
    try {
      await updateArea({ isDeleted: true }, areaId);
      setEditArea(null);
      props.fetchAreas();
    } catch (err) {
      toast.error(err.message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    props.setLoading(false);
  };

  return (
    <>
      {props.isLoggedin && (
        <PlantForm
          isLoading={props.isLoading}
          isArea={true}
          editArea={editArea}
          resetEdit={resetEdit}
          handleForm={addUpdateArea}
        />
      )}
      <PlantAreaList
        isLoading={props.isLoading}
        isLoggedin={props.isLoggedin}
        showPlants={showPlants}
        fetchedAreas={props.fetchedAreas}
        setEditArea={setEditArea}
        deleteAreaAndPlants={deleteAreaAndPlants}
      />
    </>
  );
};

export default PlantAreas;
